export const changeTitle = (newTitle) => {
  return (document.title = newTitle);
};
